/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The version of SAP this data represents. The versions apply to different historical data and are included here for completeness.  ie.  RdSAP 2012 is version 9.92, 9.93 and 9.94
 */
export type SapVersion = '9.92' | '9.93' | '9.94';

export const SapVersion = {
    _92: '9.92' as SapVersion,
    _93: '9.93' as SapVersion,
    _94: '9.94' as SapVersion
};

